<template>
<div v-if="pocs && pocs.length">
    <h3 class="font-weight-bolder text-primary my-3 h5">
        {{ $t('BrandComplex.popularIn') }} {{ categoryName }}
    </h3>
    <div class="splide newFeatureSlider" :class="addPrefixToCategoryId(aCategoryId)" :aria-label="`Slider for ${categoryName}`">
        <div class="splide__track mask-container ">
            <div class="splide__list">
                <div class="splide__slide" v-for="(singlePoc, i) in pocs" :key="i">
                    <singlePoc :singlePoc="singlePoc" :isDevMioActive="isDevMioActive" :realUrl="constructUrl(singlePoc)" :showBadgeTooltip="showBadgeTooltip" :key="i" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import Splide from '@splidejs/splide';
import singlePoc from './SinglePoc.vue';
import helperfunctions from "../../services/helperfunctions.js";

export default {

    name: "categoryFeature",
    components: {
        singlePoc
    },
    data() {
        return {
            loading: false,
            page: 1,
            error: false,
            result: null,
            pocs: [],
            splide: null,
            metaCount: 0,
            categoryName: "",
            currentPage: 1,
            isDevMioActive: false,
        };
    },
    props: {
        aCategoryId: String,
        brandData: Object,
        categories: Array,
        settingsPerm: Object,
        perPageBreakpoints: {
            type: Object,
            default: () => ({
                default: 3,
                1600: 3,
                1280: 2,
                991: 2,
                767: 1,
                575: 1
            })
        },
        showBadgeTooltip: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
            this.isDevMioActive = this.settingsPerm.isDevMioActive;
        }

        if (this.aCategoryId && this.aCategoryId.length && this.brandData && this.brandData.slug) {
            this.getPocForCategory();
        }
        if (this.categories && this.categories.length && this.aCategoryId) {
            this.categoryName = this.categories.find((cat) => cat._id === this.aCategoryId).name;
        }
    },

    methods: {
        addPrefixToCategoryId(categoryId) {
                // Add a fixed prefix, e.g., 'cat-' to every categoryId
                return `cat${categoryId}`;
        },

        getPocForCategory() {
            let catId = this.aCategoryId;
            let pageSize = 10;
            queryAndMutaionService.getPocDataForCategory(this.brandData.slug, this.brandData._id, catId, this.page, pageSize).then((data) => {
                if (data.pieceOfContent && data.pieceOfContent.Meta && data.pieceOfContent.Meta.count) {
                    this.metaCount = data.pieceOfContent.Meta.count;
                }
                if (data && data.pieceOfContent && data.pieceOfContent.PieceOfContent && data.pieceOfContent.PieceOfContent.length) {
                    data.pieceOfContent.PieceOfContent.forEach((poc) => {
                        var singlePoc = poc;
                        this.pocs.push(singlePoc);
                        this.mount_splide();
                    });
                }
                this.loading = false;
            }).catch((error) => {
                this.error = error;
                this.loading = false;
            });
            this.page++;
        },
        
        constructUrl(singlePoc) {
            //construct url
            return helperfunctions.generateUrlForPocs(singlePoc);

        },
        addMovedEventListener() {
            this.splide.on("moved", (newIndex) => {
                const lastCardIndex = newIndex + this.splide.options.perPage;
                if (lastCardIndex === this.pocs.length - 2 && this.pocs.length > this.metaCount) {
                    this.getPocForCategory();
                }
            });
        },

        mount_splide: function () {
            let thiz = this;
            let padding = {
                right: "0rem",
                left: "0rem",
            };
            setTimeout(function () {
                if (thiz.pocs && thiz.pocs.length && thiz.pocs.length > 3) {
                    padding = {
                        right: "0rem",
                        left: "0rem",
                    };
                }
                if (!thiz.splide) {
                    thiz.splide = new Splide('.' + thiz.addPrefixToCategoryId(thiz.aCategoryId), {
                        classes: {
                            arrows: 'splide__arrows arrows',
                            prev: 'splide__arrow--prev prev',
                            next: 'splide__arrow--next next',
                        },
                        perPage: thiz.perPageBreakpoints.default,
                        perMove: 1,
                        gap: '1rem',
                        rewind: false,
                        pagination: false,
                        padding: padding,
                        breakpoints: {
                            1600: {
                                perPage: thiz.perPageBreakpoints[1600],
                            },
                            1280: {
                                perPage: thiz.perPageBreakpoints[1280],
                            },
                            991: {
                                perPage: thiz.perPageBreakpoints[991],
                            },
                            767: {
                                perPage: thiz.perPageBreakpoints[767],
                            },
                            575: {
                                perPage: thiz.perPageBreakpoints[575],
                                padding: {
                                    left: '0rem',
                                    right: '5rem'
                                },
                                arrows: false,
                                start: 1,
                            },
                        },

                    });
                    thiz.splide.mount();
                    thiz.addMovedEventListener();
                } else {
                    thiz.splide.refresh(); // Refresh the existing Splide instance
                }
            }, 100);
        },

    },

};
</script>

<style scoped>
.mask-container {
    position: relative;
    overflow: hidden;
}

.mask-container::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 94%;
    transform: translateX(-50%);
    width: 22%;
    background: linear-gradient(to right, transparent, white);
    filter: blur(10px);
}

.prev {
    left: 68.5rem !important;
    background-color: transparent !important;
}

.next {
    right: -0.5rem !important;
    background-color: transparent !important;
}

.arrows {
    position: relative !important;
    top: -20px;
}

@media screen and (max-width: 1679px) {
    .prev {
        left: 54rem !important;
    }

    .next {
        right: 0rem !important;
    }

    .arrows {
        top: -20px;
    }
}

@media screen and (max-width: 1359px) {
    .prev {
        left: 46rem !important;
    }

    .next {
        right: 0rem !important;
    }

    .arrows {
        top: -20px;
    }
}

@media screen and (max-width: 1199px) {
    .prev {
        left: 38rem !important;
    }

    .next {
        right: 0rem !important;
    }

    .arrows {
        top: -20px;
    }
}

@media screen and (max-width: 767px) {
    .prev {
        left: 26rem !important;
    }

    .next {
        right: 0rem !important;
    }

    .arrows {
        top: -20px;
    }
}
</style>
